import React from "react";
import { SortableElement, sortableHandle } from "react-sortable-hoc";
import { IconButton, Tooltip, TableCell, TableRow } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import { styles } from "./styles";

const DragHandle = sortableHandle(() => <i className="fa fa-bars" />);

const SortableRow = SortableElement(({ row, index, classes, itemActionButtons, reOrder }) => {
  return (
    <TableRow key={`row-${index}`} classes={{ root: classes.tableCell }} {...row.getRowProps()}>
      {reOrder ? (
        <TableCell>
          <IconButton classes={{ root: classes.reorderButton }}>
            <DragHandle />
          </IconButton>
        </TableCell>
      ) : null}

      {row.cells.map((cell, i) => {
        return (
          <TableCell key={`row-${index}-${i}`} {...cell.getCellProps()}>
            {cell.render("Cell")}
          </TableCell>
        );
      })}

      {!_.isEmpty(itemActionButtons) ? (
        <TableCell>
          {itemActionButtons
            .map((_action) => (_.isFunction(_action) ? _action(row.original) : _action))
            .filter((_action) => {
              return !_action.hidden;
            })
            .map((_action, i) => {
              return (
                <Tooltip key={_action.tooltip} title={_action.tooltip} aria-label={_action.tooltip}>
                  <IconButton
                    key={`${_action.tooltip}-${i}`}
                    classes={{ root: classes.itemActionButton }}
                    onClick={(e) => {
                      _action.onClick(e, row.original);
                      e.stopPropagation();
                    }}
                  >
                    {_action.icon}
                  </IconButton>
                </Tooltip>
              );
            })}
        </TableCell>
      ) : null}
    </TableRow>
  );
});

export default withStyles(styles)(SortableRow);
